// extracted by mini-css-extract-plugin
export default {"Messagebody":"MessageModal_Messagebody__6AL6X","mms":"MessageModal_mms__FTFR-","note":"MessageModal_note__qKwae"};